import { toggleModal } from './modal.js';

export function initMenu() {
  const modalMenu = document.querySelector('.mobile-menu-overlay');
  const modalMenuOpenBtn = document.querySelector('.burger-btn');

  if (modalMenu && modalMenuOpenBtn) {
    modalMenuOpenBtn.addEventListener('click', () => toggleModal('open', modalMenu));
    modalMenu.addEventListener('click', ({ target }) => {
      if (target.tagName !== 'A' && target.tagName !== 'BUTTON') {
        toggleModal('close', modalMenu);
      }
    });
  }
}
